import { useEffect, useState } from "react";
import UserSlotPicker from "./UserSlotPicker";

const SlotSelectionCard = ({ bookingData, setBookingData, isPage }) => {
  const [selectedSlot, setSelectedSlot] = useState(
    bookingData.slotSnapshot
      ? {
          date: bookingData.slotSnapshot.date,
          startTime: bookingData.slotSnapshot.startTime,
          endTime: bookingData.slotSnapshot.endTime,
          availabilityId: bookingData.slotAvailabilityId,
        }
      : null,
  );

  const [lng, lat] = bookingData.location.coordinates || [];

  useEffect(() => {
    if (window.innerWidth < 1024) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  /* SLOT VALIDATION */
  useEffect(() => {
    setBookingData((prev) => ({
      ...prev,
      __slotValid: !!selectedSlot,
    }));
  }, [selectedSlot, setBookingData]);

  /* SLOT CHANGE HANDLER */
  const handleSlotChange = (slot) => {
    setSelectedSlot(slot);

    if (!slot) {
      setBookingData((prev) => ({
        ...prev,
        slotAvailabilityId: null,
        slotSnapshot: null,
        __slotValid: false,
      }));
      return;
    }

    setBookingData((prev) => ({
      ...prev,
      slotAvailabilityId: slot.availabilityId,
      slotSnapshot: {
        date: slot.date,
        startTime: slot.startTime,
        endTime: slot.endTime,
      },
      __slotValid: true,
    }));
  };

  return (
    <div className="w-full max-w-3xl mx-auto space-y-6">
      {/* TITLE */}
      <div className="text-center">
        <h2 className="text-xl font-bold text-gray-900">
          Select Date & Time Slot
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Available slots are based on your selected location
        </p>
      </div>

      {/* SLOT PICKER */}
      <div>
        <UserSlotPicker
          value={selectedSlot}
          isPage={isPage}
          latitude={lat}
          longitude={lng}
          onChange={handleSlotChange}
        />
      </div>
    </div>
  );
};

export default SlotSelectionCard;
